import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { publishRules, removalReasons } from "@/pages/home/data";

type TabKey = "publish" | "remove";

export default function RulesSection() {
  const [tab, setTab] = useState<TabKey>("publish");
  const isPublish = tab === "publish";
  const items = isPublish ? publishRules : removalReasons;

  return (
    <section id="rules" className="scroll-mt-20 w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="发布规则"
          title="发布规则与删除原因，一次讲清"
          description="内容通过审核后并非“一发了之”。下面分别说明发布时会怎么标注、由谁拟定标题，以及哪些情况下内容会被下架。"
        />

        <div className="mt-8 inline-flex items-center gap-1 p-1 rounded-full bg-background-200">
          <button
            type="button"
            onClick={() => setTab("publish")}
            aria-pressed={isPublish}
            className={`px-4 md:px-5 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isPublish
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            发布规则
          </button>
          <button
            type="button"
            onClick={() => setTab("remove")}
            aria-pressed={!isPublish}
            className={`px-4 md:px-5 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              !isPublish
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            删除原因
          </button>
        </div>

        <div className="mt-6 md:mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <ul className="lg:col-span-2 space-y-3">
            {items.map((text, i) => (
              <li
                key={text}
                className="flex gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200"
              >
                <span
                  className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-md text-sm font-semibold ${
                    isPublish
                      ? "bg-secondary-100 text-secondary-700"
                      : "bg-primary-100 text-primary-700"
                  }`}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-sm leading-relaxed text-foreground-700">{text}</p>
              </li>
            ))}
          </ul>

          <aside className="lg:col-span-1">
            <div className="p-5 md:p-6 rounded-lg bg-secondary-900 text-background-100 h-full">
              <h3 className="font-heading text-lg font-semibold text-background-50">
                {isPublish ? "发布后的状态标签" : "下架后的处理方式"}
              </h3>
              <ul className="mt-4 space-y-3 text-sm">
                {(isPublish
                  ? [
                      { label: "已核验", desc: "证据充分，事实链条完整" },
                      { label: "待补充证据", desc: "核心事实成立，材料仍在补全" },
                      { label: "各方回应中", desc: "已通知相关方，等待说明" },
                    ]
                  : [
                      { label: "原链接保留", desc: "显示删除原因与生效时间" },
                      { label: "查询编号同步", desc: "投稿人可查到下架结论" },
                      { label: "可申请复核", desc: "补充新证据后可再次提交" },
                    ]
                ).map((row) => (
                  <li key={row.label} className="flex flex-col gap-1">
                    <span className="inline-flex w-fit px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-secondary-950">
                      {row.label}
                    </span>
                    <span className="text-background-200/90 leading-relaxed">
                      {row.desc}
                    </span>
                  </li>
                ))}
              </ul>
              <a
                href="#faq"
                className="mt-6 inline-flex items-center gap-1.5 text-sm text-accent-300 hover:text-accent-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看常见问题
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}